module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_lab-aae184981ac9fa136e74f8aef6fddd28.svg";